/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingSessionUpdateRequest
 */
export interface TrainingSessionUpdateRequest {
    /**
     * 
     * @type {Date}
     * @memberof TrainingSessionUpdateRequest
     */
    sessionDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionUpdateRequest
     */
    startTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionUpdateRequest
     */
    endTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingSessionUpdateRequest
     */
    sessionExtraFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionUpdateRequest
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionUpdateRequest
     */
    publicNotes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionUpdateRequest
     */
    privateNotes?: string | null;
}

/**
 * Check if a given object implements the TrainingSessionUpdateRequest interface.
 */
export function instanceOfTrainingSessionUpdateRequest(value: object): value is TrainingSessionUpdateRequest {
    return true;
}

export function TrainingSessionUpdateRequestFromJSON(json: any): TrainingSessionUpdateRequest {
    return TrainingSessionUpdateRequestFromJSONTyped(json, false);
}

export function TrainingSessionUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingSessionUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionDate': json['sessionDate'] == null ? undefined : (new Date(json['sessionDate'])),
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'sessionExtraFee': json['sessionExtraFee'] == null ? undefined : json['sessionExtraFee'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'publicNotes': json['publicNotes'] == null ? undefined : json['publicNotes'],
        'privateNotes': json['privateNotes'] == null ? undefined : json['privateNotes'],
    };
}

export function TrainingSessionUpdateRequestToJSON(json: any): TrainingSessionUpdateRequest {
    return TrainingSessionUpdateRequestToJSONTyped(json, false);
}

export function TrainingSessionUpdateRequestToJSONTyped(value?: TrainingSessionUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionDate': value['sessionDate'] == null ? value['sessionDate'] : value['sessionDate'].toISOString().substring(0,10),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'sessionExtraFee': value['sessionExtraFee'],
        'notes': value['notes'],
        'publicNotes': value['publicNotes'],
        'privateNotes': value['privateNotes'],
    };
}

